// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ArrowLink-Wrapper-Syn_ax","Arrow":"ArrowLink-Arrow-2XWwqa"};